import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Table,
} from 'reactstrap';
import apiResponseHandler from '../../../utils/apiResponseHandler';
import { TARole, taRolesApiService } from '../../../services/TARolesApiService';
import { PageRoute } from '../../../types/AppTypes';

const TARoleList: React.FC = () => {
  const [roles, setRoles] = useState<TARole[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    taRolesApiService
      .listRoles()
      .then((data) => {
        setRoles([...data].sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch((err) => {
        apiResponseHandler.handleApiError('Failed to load T&A roles', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section className="dashboard">
      <div className="header bg-primary pb-6">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6">
                <h6 className="h2 text-white d-inline-block mb-0">
                  Time &amp; Attendance Roles
                </h6>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container fluid className="mt--7">
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader>
                <h3 className="mb-0">Roles &amp; Capabilities</h3>
              </CardHeader>
              <CardBody>
                {loading ? (
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Codename</th>
                        <th>Capabilities</th>
                        <th style={{ width: '120px' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roles.map((role) => (
                        <tr key={role.id}>
                          <td>{role.name}</td>
                          <td>
                            <code>{role.codename}</code>
                          </td>
                          <td>{role.capabilities?.length ?? 0}</td>
                          <td>
                            <Link
                              className="btn btn-sm btn-primary"
                              to={`/admin${PageRoute.TARoleDetail.replace(
                                ':roleId',
                                role.id,
                              )}`}>
                              Edit
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
                {!loading && roles.length === 0 && (
                  <p className="text-muted mb-0">No T&amp;A roles found.</p>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TARoleList;
